<template>
  <li>
    <!--- Input question MODAL -->
    <Modal
      :width="400"
      :value="inputModalOpen"
      ctaText="Add"
      actions-border
      overlayColor="#ffffff"
      overlayOpacity="0.83"
      @cancel="inputModalOpen = false"
      title="Add input question"
      @confirm="confirmInputQuestionModal">
      <template #default>
        <label class="default-question__label"> {{ $t("shortcodes.live_chat_auto.default_question") }} </label>
        <v-select
          v-model="inputQuestionValue"
          class="input-question__select"
          hide-details
          :items="inputQuestionOptions"
          :menu-props="{
            offsetOverflow: true,
            offsetY: true,
          }"
          placeholder="Default question">
        </v-select>
      </template>
    </Modal>
    <!--- Input question MODAL end -->
    <span
      class="tree-item"
      :class="{ 'tree-item--error': node._telHrefError }"
>
      <div class="sender-indicator">
        <div class="d-flex align-center">
          <v-tooltip v-if="node.pageType === 'decision'" top>
            <template #activator="{ on }">
              <div v-on="on">
                <v-icon class="sender-indicator--forum mr-2">mdi-eye-off-outline</v-icon>
              </div>
            </template>
            <span>This page type is not displayed to the user</span>
          </v-tooltip>

          <span v-if="node.pageType === 'page'">
            Page
            <v-icon v-if="isLastPageInBranch" class="ml-1" color="green" size="16">mdi-message-arrow-right</v-icon>
          </span>
          <span v-if="node.pageType === 'inputQuestion'">Input question</span>
          <span v-if="node.pageType === 'zipInputQuestion'">ZIP input question</span>
          <span v-if="node.pageType === 'action'"
            >Action
            <!-- Just so it's clear what is the order of the actions -->
            <span v-if="node.pageType === 'action'">{{ index + 1 }}</span>
          </span>
          <span v-if="node.pageType === 'decision'">Decision</span>
        </div>
      </div>
      <div v-if="parent" @click="removeNode" class="remove-node">
        <v-icon>mdi-trash-can-outline</v-icon>
      </div>
      <div v-if="node.pageType === 'action' || node.pageType === 'decision'" @click="copyNode" class="copy-node">
        <v-icon>mdi-dock-window</v-icon>
      </div>
      <div>
        <div class="message-item">
          <MultiStepFormPage
            ref="page"
            v-if="node.pageType === 'page'"
            :node.sync="node"
            :form-text-color="formTextColor"></MultiStepFormPage>
          <MultiStepFormInputQuestion
            ref="inputQuestion"
            v-if="node.pageType === 'inputQuestion'"
            :node.sync="node"></MultiStepFormInputQuestion>
          <MultiStepFormAction v-if="node.pageType === 'action'" :node.sync="node"></MultiStepFormAction>
          <MultiStepFormZipInput v-if="node.pageType === 'zipInputQuestion'" :node.sync="node"></MultiStepFormZipInput>
          <MultiStepFormDecision
            v-if="node.pageType === 'decision' && (!parent || parent.pageType !== 'zipInputQuestion')"
            :node.sync="node"></MultiStepFormDecision>
          <MultiStepFormZipDecision
            v-if="node.pageType === 'decision' && parent && parent.pageType === 'zipInputQuestion'"
            :node.sync="node"></MultiStepFormZipDecision>
        </div>
        <v-btn class="mr-2" v-if="displayAddPageBtn" @click="addPage">Add page</v-btn>
        <v-btn v-if="displayAddInputQuestion" @click="openInputQuestionModal">Add input question</v-btn>
        <v-btn v-if="displayAddActionBtn" @click="addAction">Add action</v-btn>
        <v-btn v-if="displayAddDecision" @click="addDecision">Add decision</v-btn>
      </div>
    </span>
    <ul v-if="node.children && node.children.length">
      <MultiStepFormTreeNode
        v-for="(child, index) in node.children"
        ref="children"
        :index="index"
        :key="child.id"
        :node="child"
        :parent="node"
        :lastPageMap="lastPageMap"
        :form-template="formTemplate"
        :form-text-color="formTextColor"
        @openModal="$emit('openModal', $event)"
        @recomputeLastPageMap="$emit('recomputeLastPageMap')"></MultiStepFormTreeNode>
    </ul>
  </li>
</template>

<script>
  import cloneDeep from "lodash/cloneDeep";
  import MultiStepFormPage from "./MultiStepFormPage.vue";
  import MultiStepFormInputQuestion from "./MultiStepFormInputQuestion.vue";
  import MultiStepFormAction from "./MultiStepFormAction.vue";
  import MultiStepFormZipInput from "./MultiStepFormZipInput.vue";
  import MultiStepFormDecision from "./MultiStepFormDecision.vue";
  import MultiStepFormZipDecision from "./MultiStepFormZipDecision.vue";
  import Modal from "@/components/custom/Modal.vue";
  import { PAGE, INPUT_QUESTION, ZIP_INPUT_QUESTION, ACTION, DECISION, TEMPLATE_PRESETS } from "./constant";
  import { v4 as uuidv4 } from "uuid";

  /* eslint-disable */
  export default {
    name: "MultiStepFormTreeNode",
    components: {
      MultiStepFormPage,
      MultiStepFormInputQuestion,
      MultiStepFormAction,
      MultiStepFormZipInput,
      MultiStepFormDecision,
      MultiStepFormZipDecision,
      Modal,
    },
    props: {
      node: {
        type: Object,
        required: true,
      },
      parent: {
        type: Object,
        default: null,
      },
      index: {
        type: Number,
      },
      lastPageMap: {
        type: Object,
        default: () => ({}),
      },
      formTemplate: {
        type: String,
        default: "dark",
      },
      formTextColor: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        // Input question modal
        inputModalOpen: false,
        inputQuestionValue: "enter_age",
        inputQuestionOptions: [
          { text: "Enter your age", value: "enter_age" },
          { text: "Enter your birth year", value: "enter_birth_year" },
          { text: "Enter your birth year (Underscore)", value: "enter_birth_year_underscore" },
          { text: "Enter ZIP code", value: "enter_zip" },
        ],
      };
    },
    computed: {
      displayAddPageBtn() {
        if (this.node.pageType === "decision" || this.node.pageType === "action") return true;
        if (this.node.pageType === "page") {
          const hasActionOrInput = this.node.children.some(
            c => c.pageType === "action" || c.pageType === "inputQuestion" || c.pageType === "zipInputQuestion",
          );
          const hasChildPage = this.node.children.some(c => c.pageType === "page");
          return !hasActionOrInput && !hasChildPage;
        }
        return false;
      },
      displayAddInputQuestion() {
        if (this.node.pageType !== "page") return false;
        return !this.node.children.some(
          c => c.pageType === "inputQuestion" || c.pageType === "zipInputQuestion" || c.pageType === "action",
        );
      },
      displayAddActionBtn() {
        if (this.node.pageType !== "page") return false;
        return !this.node.children.some(c => c.pageType === "inputQuestion" || c.pageType === "zipInputQuestion");
      },
      displayAddDecision() {
        if (this.node.pageType === "inputQuestion") return true;
        if (this.node.pageType === "zipInputQuestion") {
          return !this.node.children?.some(c => c.pageType === "decision");
        }
        return false;
      },
      isLastPageInBranch() {
        if (this.node.pageType !== "page") {
          return false;
        }

        // Prefer map from parent if provided and node has id
        if (this.node.id && this.lastPageMap && Object.keys(this.lastPageMap).length > 0) {
          return !!this.lastPageMap[this.node.id];
        }
        // Fallback: compute locally by checking if there are any descendant pages
        return !this.hasDescendantPage(this.node);
      },
    },
    watch: {
      isLastPageInBranch: {
        immediate: true,
        handler(isLast) {
          if (this.node.isLastPage !== isLast) {
            this.$set(this.node, "isLastPage", isLast);
          }
        },
      },
      "node.content"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
      "node.text"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
      "node.value"() {
        if (this.node._telHrefError) this.$delete(this.node, "_telHrefError");
      },
    },
    beforeMount() {
      this.ensureIds(this.node);
    },
    methods: {
      ensureIds(node, overrideId = false, usedIds = new Set()) {
        // If ID is missing, forced to override, or already used — generate a new one
        if (!node.id || overrideId || usedIds.has(node.id)) {
          node.id = uuidv4();
        }

        // Add the current ID to the used set
        usedIds.add(node.id);

        // Recurse into children
        if (Array.isArray(node.children)) {
          node.children.forEach(child => {
            this.ensureIds(child, overrideId, usedIds);
          });
        }
      },
      hasDescendantPage(node) {
        if (!node || !Array.isArray(node.children) || node.children.length === 0) return false;
        for (let i = 0; i < node.children.length; i += 1) {
          const child = node.children[i];
          if (child.pageType === "page") return true;
          if (this.hasDescendantPage(child)) return true;
        }
        return false;
      },
      copyNode() {
        const copiedNode = cloneDeep(this.node);
        this.ensureIds(copiedNode, true);
        let children = this.parent.children;
        this.parent.children = [];
        // as we clone a node, we need to access parent ref and update newly created node,
        // but with huge amount of refs its prone for mistakes and less efficient option is chosen
        this.$nextTick(() => {
          children.splice(this.index + 1, 0, copiedNode);
          this.parent.children = children;
        });
      },
      removeNode() {
        const hasChildren = this.node.children.length > 0;
        if ((this.node.pageType === "action" || this.node.pageType === "decision") && hasChildren) {
          this.$emit("openModal", {
            title: "Warning!",
            subtitle: `If ${this.node.pageType === "action" ? "an action" : "a decision"} is deleted, all pages coming after it will also be deleted.`,
            ctaText: "Delete",
            delete: true,
            index: this.index,
            parent: this.parent,
          });
        } else if ((this.node.pageType === "inputQuestion" || this.node.pageType === "zipInputQuestion") && hasChildren) {
          this.$emit("openModal", {
            title: "Cannot delete!",
            subtitle:
              '"Input question" cannot be deleted, because it still has decisions that belong to it. Decisions will not function without "Input question".',
            ctaText: "Ok, understood",
            delete: false,
            cancelHidden: true,
          });
        } else if (this.node.children.length > 0) {
          const children = this.node.children;
          this.updateTreeContent(children, this);
          this.parent.children = children;
        } else {
          this.parent.children.splice(this.parent.children.indexOf(this.node), 1);
        }
      },
      addPage() {
        const page = cloneDeep(PAGE);
        // When adding a child page to a page, default delay to 3000ms
        // unless parent has progress bar or checking element (those already have their own timing)
        if (this.node.pageType === "page") {
          const hasProgressOrChecking =
            (this.node.progressBar && this.node.progressBar.enabled) ||
            (this.node.checkingElement && this.node.checkingElement.enabled);
          page.delay = hasProgressOrChecking ? 0 : 3000;
        }
        // Ensure the new page has an ID immediately
        this.ensureIds(page);
        if (this.node.children.length > 0) {
          const children = this.node.children;
          page.children = children;
          this.updateTreeContent([page], this.$refs.children[0]);
          this.node.children = [page];
        } else {
          this.node.children.push(page);
        }

        // Force immediate computation of isLastPage for new pages
        this.$nextTick(() => {
          // Trigger recompute through event emission
          this.$emit("recomputeLastPageMap");
        });
      },
      // Input question modal
      openInputQuestionModal() {
        this.inputModalOpen = true;
      },
      confirmInputQuestionModal() {
        this.inputModalOpen = false;
        this.addInputQuestion();
      },
      addInputQuestion() {
        const preset = TEMPLATE_PRESETS[this.formTemplate] || TEMPLATE_PRESETS.dark;
        if (this.inputQuestionValue === "enter_zip") {
          const zipQuestion = cloneDeep(ZIP_INPUT_QUESTION);
          zipQuestion.buttonColor = preset.inputButtonBackgroundColor;
          zipQuestion.buttonTextColor = preset.inputButtonTextColor;
          zipQuestion.buttonBorderColor = preset.inputButtonBorderColor;
          this.node.children.push(zipQuestion);
        } else {
          const inputQuestion = cloneDeep(INPUT_QUESTION);
          inputQuestion.inputQuestionType = this.inputQuestionValue;
          inputQuestion.buttonColor = preset.inputButtonBackgroundColor;
          inputQuestion.buttonTextColor = preset.inputButtonTextColor;
          inputQuestion.buttonBorderColor = preset.inputButtonBorderColor;
          this.node.children.push(inputQuestion);
        }
      },
      addAction() {
        const action = cloneDeep(ACTION);
        const preset = TEMPLATE_PRESETS[this.formTemplate] || TEMPLATE_PRESETS.dark;
        action.backgroundColor = preset.actionBackgroundColor;
        action.textColor = preset.actionTextColor;
        action.borderColor = preset.actionBorderColor;
        action.padding = preset.actionPadding;
        // Ensure the new action has an ID immediately
        this.ensureIds(action);
        // Actions should be added as siblings (not wrapping existing children)
        // This allows multiple actions to appear side by side
        this.node.children.push(action);
      },
      addDecision() {
        const decision = cloneDeep(DECISION);
        this.node.children.push(decision);
      },
      // Edit at your own risk
      updateTreeContent(children, ref) {
        let index = ref?.index ? ref.index : 0;
        if (children[index].pageType === "page" && ref && ref.$refs.page) {
          ref.$refs.page.updateContent(children[index].content);
          ref.$refs.page.showEditor = !children[index].content;
          if (children[index].children?.length > 0 && ref.$refs.children) {
            this.updateTreeContent(children[index].children, ref.$refs.children[index]);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  .sender-indicator {
    position: absolute;
    top: 10px;
    left: 10px;
    &--forum {
      color: #2377f8 !important;
    }
  }
  .tree-item {
    padding: 45px 10px 10px 10px;
    border-radius: 5px;
    &--error {
      border: 3px dashed get-color("error") !important;
    }
  }
  .remove-node {
    padding: 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 2;
  }

  .copy-node {
    padding: 5px 35px 5px 5px;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    z-index: 1;
  }
</style>
